import { MarketplaceFormData } from '~admin/view/components/details/marketplace-details/marketplace-details-fields.component';
import { MarketplaceRequest } from '~client/model/admin/marketplace-request';
import { MarketplaceType } from '~client/model/marketplace-type';

/**
 * Transforms MarketplaceFormData to Partial<MarketplaceRequest>
 * @param marketplaceFormData
 */
export const getMarketplaceAdditionalDetailsRequest = (
  marketplaceFormData: MarketplaceFormData,
): Pick<MarketplaceRequest, 'displayOptions' | 'forceAutoPay' | 'parentId' | 'shippingMethod'> => {
  const { type } = marketplaceFormData;

  return {
    displayOptions: 'NotUsedDisplayOptions',
    forceAutoPay: type === MarketplaceType.AUCTION,
    parentId: null,
    shippingMethod: 'NotUsedShippingMethod',
  };
};



// WEBPACK FOOTER //
// ./view/components/create-event/helper/marketplace-request/marketplace-additional-details-request.helper.ts